import { CustomerTag } from '@fgb/core';

export class Tags {
  public static rallyCap = new CustomerTag(undefined, undefined, 'RallyCap');
}
